import React from "react";
import { Download } from "lucide-react";
import { BACKEND_URL } from "../lib/api";

export const money = (n) => `$${Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;

export function Kpi({ label, value, sub, testid }) {
  return (
    <div className="bg-white border border-[var(--line)] rounded-2xl p-4 md:p-5" data-testid={testid}>
      <p className="text-[10px] uppercase tracking-[0.18em] text-[var(--muted)]">{label}</p>
      <p className="font-serif text-3xl mt-1">{value}</p>
      {sub && <p className="text-xs text-[var(--muted)] mt-0.5">{sub}</p>}
    </div>
  );
}

export function RangePicker({ days, setDays }) {
  return (
    <div className="inline-flex bg-white border border-[var(--line)] rounded-full p-1" data-testid="report-range">
      {[30, 90, 365].map((d) => <button key={d} onClick={() => setDays(d)} data-testid={`report-range-${d}`} className={`px-4 py-1.5 rounded-full text-xs ${days === d ? "bg-[var(--ink)] text-white" : "text-[var(--muted)]"}`}>{d === 365 ? "1 year" : `${d} days`}</button>)}
    </div>
  );
}

export function ExportButtons({ path, testid }) {
  return (
    <div className="flex gap-2" data-testid={testid}>
      {["csv", "pdf"].map((f) => (
        <a key={f} href={`${BACKEND_URL}/api${path}${path.includes("?") ? "&" : "?"}fmt=${f}`} className="btn-outline-gold !py-2 !px-4 text-[11px]" data-testid={`${testid}-${f}`}>
          <Download className="w-3.5 h-3.5" /> {f === "csv" ? "Spreadsheet" : "PDF"}
        </a>
      ))}
    </div>
  );
}

export function Breakdown({ title, data, testid, fmt = (v) => v }) {
  const entries = Object.entries(data || {});
  const max = Math.max(1, ...entries.map(([, v]) => Number(typeof v === "object" ? v.amount ?? v.count : v) || 0));
  return (
    <div className="bg-white border border-[var(--line)] rounded-2xl p-5" data-testid={testid}>
      <p className="text-[11px] uppercase tracking-[0.18em] text-[var(--muted)] mb-3">{title}</p>
      {entries.length === 0 && <p className="text-sm text-[var(--muted)]">Nothing yet.</p>}
      <div className="space-y-2">
        {entries.map(([k, v]) => {
          const n = Number(typeof v === "object" ? v.amount ?? v.count : v) || 0;
          return (
            <div key={k}>
              <div className="flex justify-between text-sm"><span className="capitalize">{k.replace(/_/g, " ")}</span><span className="font-medium">{typeof v === "object" ? `${v.count} · ${money(v.amount)}` : fmt(v)}</span></div>
              <div className="h-1.5 rounded-full bg-[var(--bg)] mt-1 overflow-hidden"><div className="h-full rounded-full bg-[var(--gold)] transition-[width] duration-700" style={{ width: `${(n / max) * 100}%` }} /></div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
